<template>
  <div class="customer-review">
    <index-view title="Review cửa hàng" :filters="filters" :getData="getData" :headers="mainHeaders">
      <template #viewSection="{ item }">
        <detail :item="item"></detail>
      </template>
    </index-view>
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { get } from './api'
import { main } from './header'
import Detail from './Detail.vue'
export default {
  name: "CustomerReview",
  components: {
    IndexView,
    Detail
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    }
  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'phoneNumber', label:'SDT', type: 'text', value: '' },
      ],
      // mainData: []
    }
  },
  methods: {
    getData: get
  }
}
</script>